/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import React from 'react';
import Icon from '@ant-design/icons';

function ReplaySvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
      <path
        d="M16.68 22.2a52.39 52.39 0 0 0-5.06 7.46C5.63 40.31 3.1 52.39 4.13 64.2 5.14 75.74 9.56 87.03 17.5 96.47c2.85 3.39 5.91 6.38 9.13 8.97 11.11 8.93 24.28 13.34 37.41 13.22 13.13-.12 26.21-4.78 37.14-13.98 3.19-2.68 6.18-5.73 8.91-9.13 6.4-7.96 10.51-17.29 12.07-27.14 1.53-9.67.59-19.83-3.07-29.66-3.49-9.35-8.82-17.68-15.78-24.21C96.7 8.33 88.59 3.76 79.2 1.48 76.26.77 73.26.3 70.21.11c-3.06-.2-6.19-.13-9.4.22a3.662 3.662 0 0 0 .8 7.28c2.78-.31 5.49-.37 8.14-.19 2.65.17 5.23.57 7.73 1.17 8.11 1.96 15.1 5.91 20.84 11.29 6.14 5.75 10.85 13.12 13.94 21.43 3.21 8.61 4.04 17.51 2.7 25.96C113.59 75.85 110 84 104.4 90.96c-2.47 3.07-5.12 5.78-7.91 8.13-9.59 8.07-21.03 12.15-32.5 12.26-11.47.11-23-3.76-32.76-11.61-2.9-2.33-5.62-4.98-8.13-7.97-6.92-8.22-10.77-18.09-11.65-28.2-.91-10.38 1.32-20.99 6.57-30.33 1.59-2.82 3.21-5.07 5.01-7.24l.53 14.7c.07 2.02 1.76 3.6 3.78 3.53 2.02-.07 3.6-1.76 3.53-3.78l-.85-23.42a3.647 3.647 0 0 0-3.78-3.52l-.37.03-22.7 3.19c-2 .28-3.4 2.12-3.12 4.13.28 2 2.12 3.4 4.13 3.12l12.5-1.78zm69.1 36.51L53.11 80.65V37.12l32.67 21.59z"
        fill="#7A8E9D"
      />
    </svg>
  );
}

export default function ReplayIcon(props: {
  style?: React.CSSProperties;
  className?: string;
}) {
  return <Icon component={ReplaySvg} {...props} />;
}
